import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: () => import('@/views/Home'),
    },
    {
        path: '/show',
        name: 'Show',
        component: () => import('@/views/Show'),
    },
    {
        path: '/preview',
        name: 'Preview',
        component: () => import('@/views/Preview'),
    },
    {
        path: '/history',
        name: 'History',
        component: () => import('@/views/History'),
    },
]

export default new Router({
    mode: 'history',
    routes,
})
